module.exports = __webpack_public_path__ + "static/media/longhair.9662623b.jpg";